var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 96,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    x: 0.5,
    fill: "#FBF2B3",
    rx: 48
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7D6F0B",
    d: "M44.5 60a4 4 0 1 1 8 0 4 4 0 0 1-8 0M44.892 35.98a3.62 3.62 0 1 1 7.204 0l-1.403 14.03a2.21 2.21 0 0 1-4.398 0z"
  })));
};
export default SvgWarning;